export default {
  namespaced: true,
  state: {
    /**
     * 地址列表数据
     */
    address: {},
  },
  actions: {
    /**
     * 加载数据
     */
    async loadAddressData({ commit }) {
      const address = await this.$http.get('/demo/address/list');
      console.log(address);
      commit('save', { address });
    },
  },
  mutations: {
    /**
     * 保存状态
     * @param state
     * @param payload
     */
    save(state, payload) {
      for (let key of Object.keys(payload)) {
        state[key] = payload[key];
      }
    },
  },
};
